module.exports = __webpack_public_path__ + "static/img/gpt26.6744ec86.png";